<svg id="pay-icon" [ngClass]="[getClasses(), 'mx-auto']" fill="currentColor" [attr.viewBox]="getViewBox()" xml:space="preserve">
  @switch (shape()) {
    @case (IconNames.Edit) {
      <rect x="2" y="26" width="28" height="2" />
      <path
        d="M25.4,9c0.8-0.8,0.8-2,0-2.8c0,0,0,0,0,0l-3.6-3.6c-0.8-0.8-2-0.8-2.8,0c0,0,0,0,0,0l-15,15V24h6.4L25.4,9z M20.4,4L24,7.6l-3,3L17.4,7L20.4,4z M6,22v-3.6l10-10l3.6,3.6l-10,10H6z" />
    }
    @case (IconNames.Restart) {
      <path d="M12,10H6.78A11,11,0,0,1,27,16h2A13,13,0,0,0,6,7.68V4H4v8h8Z" />
      <path d="M20,22h5.22A11,11,0,0,1,5,16H3a13,13,0,0,0,23,8.32V28h2V20H20Z" />
    }
    @case (IconNames.Add) {
      <polygon points="17,15 17,8 15,8 15,15 8,15 8,17 15,17 15,24 17,24 17,17 24,17 24,15 " />
    }
    @case (IconNames.Subtract) {
      <rect x="8" y="15" width="16" height="2" />
    }
    @case (IconNames.Close) {}
    @case (IconNames.Fire) {
      <path
        d="M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z" />
    }
    @case (IconNames.Locked) {
      <path d="M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z" />
    }
    @case (IconNames.ExclamationMark) {
      <path d="M16,23a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,23Z" />
      <rect x="15" y="12" width="2" height="9" />
      <path
        d="M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z" />
    }
    @case (IconNames.Happy) {
      <path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z" />
      <path d="M11.5,11A2.5,2.5,0,1,0,14,13.5,2.48,2.48,0,0,0,11.5,11Z" />
      <path d="M20.5,11A2.5,2.5,0,1,0,23,13.5,2.48,2.48,0,0,0,20.5,11Z" />
      <path d="M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z" />
    }
    @case (IconNames.ChevronDown) {
      <polygon points="16,22 6,12 7.4,10.6 16,19.2 24.6,10.6 26,12 " />
    }
    @case (IconNames.ChevronUp) {
      <polygon points="16,10 26,20 24.6,21.4 16,12.8 7.4,21.4 6,20 " />
    }
    @case (IconNames.ChevronUpDown) {
      <polygon points="16 28 9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28" />
      <polygon points="16 4 23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4" />
    }
    @case (IconNames.ChevronDoubleDown) {
      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
    }
    @case (IconNames.ChevronLeft) {
      <polygon points="10,16 20,6 21.4,7.4 12.8,16 21.4,24.6 20,26 " />
    }
    @case (IconNames.ChevronRight) {
      <polygon points="22,16 12,26 10.6,24.6 19.2,16 10.6,7.4 12,6 " />
    }
    @case (IconNames.Sunglasses) {
      <path
        d="M 23.558594 9.695312 L 22.714844 9.695312 C 22.566406 9.359375 22.378906 9.058594 22.15625 8.792969 C 21.382812 7.890625 20.179688 7.429688 18.578125 7.429688 L 5.425781 7.429688 C 3.820312 7.429688 2.617188 7.890625 1.84375 8.792969 C 1.621094 9.058594 1.433594 9.359375 1.285156 9.695312 L 0.441406 9.695312 C 0.195312 9.695312 0 9.890625 0 10.132812 C 0 10.378906 0.195312 10.574219 0.441406 10.574219 L 1 10.574219 C 0.902344 11.007812 0.855469 11.484375 0.855469 12 C 0.855469 14.519531 2.90625 16.570312 5.425781 16.570312 C 7.019531 16.570312 8.5625 15.839844 9.765625 14.519531 C 10.824219 13.363281 11.476562 11.867188 11.476562 10.609375 C 11.476562 10.5 11.476562 10.394531 11.476562 10.292969 C 11.648438 10.25 11.820312 10.230469 12 10.230469 C 12.179688 10.230469 12.351562 10.25 12.523438 10.292969 C 12.523438 10.394531 12.523438 10.5 12.523438 10.609375 C 12.523438 11.867188 13.175781 13.363281 14.234375 14.519531 C 15.4375 15.839844 16.980469 16.570312 18.578125 16.570312 C 21.09375 16.570312 23.144531 14.519531 23.144531 12 C 23.144531 11.484375 23.097656 11.007812 23 10.574219 L 23.558594 10.574219 C 23.804688 10.574219 24 10.378906 24 10.132812 C 24 9.890625 23.804688 9.695312 23.558594 9.695312 Z M 9.117188 13.925781 C 8.082031 15.0625 6.769531 15.691406 5.425781 15.691406 C 3.390625 15.691406 1.734375 14.035156 1.734375 12 C 1.734375 9.515625 2.941406 8.3125 5.425781 8.3125 C 8.074219 8.3125 9.535156 8.3125 10.144531 8.609375 C 10.558594 8.808594 10.597656 9.167969 10.597656 10.609375 C 10.597656 11.65625 10.03125 12.925781 9.117188 13.925781 Z M 12 9.351562 C 11.8125 9.351562 11.628906 9.367188 11.445312 9.398438 C 11.40625 8.960938 11.316406 8.597656 11.121094 8.308594 L 12.878906 8.308594 C 12.683594 8.597656 12.59375 8.960938 12.554688 9.398438 C 12.371094 9.367188 12.1875 9.351562 12 9.351562 Z M 18.578125 15.691406 C 17.230469 15.691406 15.917969 15.0625 14.882812 13.925781 C 13.96875 12.925781 13.402344 11.65625 13.402344 10.609375 C 13.402344 9.167969 13.441406 8.808594 13.855469 8.609375 C 14.464844 8.308594 15.925781 8.308594 18.578125 8.308594 C 21.058594 8.308594 22.265625 9.515625 22.265625 12 C 22.265625 14.035156 20.609375 15.691406 18.578125 15.691406 Z M 18.578125 15.691406 " />
      <path
        d="M 6.835938 9.585938 C 6.664062 9.414062 6.386719 9.414062 6.214844 9.585938 L 3.402344 12.394531 C 3.230469 12.566406 3.230469 12.847656 3.402344 13.019531 C 3.488281 13.105469 3.601562 13.148438 3.714844 13.148438 C 3.824219 13.148438 3.9375 13.105469 4.023438 13.019531 L 6.835938 10.207031 C 7.007812 10.035156 7.007812 9.757812 6.835938 9.585938 Z M 6.835938 9.585938 " />
      <path
        d="M 7.609375 10.984375 L 5.5 13.09375 C 5.328125 13.265625 5.328125 13.542969 5.5 13.714844 C 5.585938 13.800781 5.699219 13.84375 5.8125 13.84375 C 5.925781 13.84375 6.039062 13.800781 6.125 13.714844 L 8.230469 11.609375 C 8.402344 11.4375 8.402344 11.15625 8.230469 10.984375 C 8.058594 10.816406 7.78125 10.816406 7.609375 10.984375 Z M 7.609375 10.984375 " />
      <path
        d="M 19.203125 9.585938 C 19.03125 9.414062 18.75 9.414062 18.578125 9.585938 L 15.769531 12.394531 C 15.597656 12.566406 15.597656 12.847656 15.769531 13.019531 C 15.855469 13.105469 15.964844 13.148438 16.078125 13.148438 C 16.191406 13.148438 16.304688 13.105469 16.390625 13.019531 L 19.199219 10.207031 C 19.371094 10.035156 19.371094 9.757812 19.203125 9.585938 Z M 19.203125 9.585938 " />
      <path
        d="M 19.976562 10.984375 L 17.867188 13.09375 C 17.695312 13.265625 17.695312 13.542969 17.867188 13.714844 C 17.953125 13.800781 18.066406 13.84375 18.179688 13.84375 C 18.292969 13.84375 18.402344 13.800781 18.488281 13.714844 L 20.597656 11.609375 C 20.769531 11.4375 20.769531 11.15625 20.597656 10.984375 C 20.425781 10.816406 20.148438 10.816406 19.976562 10.984375 Z M 19.976562 10.984375 " />
    }
    @case (IconNames.Sun) {
      <path d="M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z" transform="translate(0 0.0049)" />
      <rect x="6.8536" y="5.3745" width="1.9998" height="4.958" transform="translate(-3.253 7.8584) rotate(-45)" />
      <rect x="2" y="15.0049" width="5" height="2" />
      <rect x="5.3745" y="23.1466" width="4.958" height="1.9998" transform="translate(-14.7739 12.6305) rotate(-45)" />
      <rect x="15" y="25.0049" width="2" height="5" />
      <rect x="23.1466" y="21.6675" width="1.9998" height="4.958" transform="translate(-10.0018 24.1514) rotate(-45)" />
      <rect x="25" y="15.0049" width="5" height="2" />
      <rect x="21.6675" y="6.8536" width="4.958" height="1.9998" transform="translate(1.5191 19.3793) rotate(-45)" />
      <rect x="15" y="2.0049" width="2" height="5" />
    }
    @case (IconNames.Info) {
      <path d="M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"></path>
      <path d="M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"></path>
    }
    @case (IconNames.Earth) {
      <path
        d="M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z" />
    }
    @case (IconNames.Purchase) {
      <path d="M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z" transform="translate(0 0)" />
      <rect x="6" y="20" width="10" height="2" />
    }
    @case (IconNames.Maximize) {
      <polygon points="20 2 20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2" />
      <polygon points="14 19.416 12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416" />
    }
    @case (IconNames.Currency) {
      <path
        d="M21,12V10H17V7H15v3H13a2.002,2.002,0,0,0-2,2v3a2.002,2.002,0,0,0,2,2h6v3H11v2h4v3h2V22h2a2.0023,2.0023,0,0,0,2-2V17a2.002,2.002,0,0,0-2-2H13V12Z" />
      <path d="M16,4A12,12,0,1,1,4,16,12.0353,12.0353,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14.0412,14.0412,0,0,0,16,2Z" />
    }
    @case (IconNames.Information) {
      <polygon points="17 22 17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22" />
      <path d="M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z" />
      <path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z" />
    }
    @case (IconNames.InformationFilled) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <path
        id="inner-path"
        class="cls-1"
        d="M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z"
        transform="translate(0 0)" />
      <path
        d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.Search) {
      <path
        d="M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.ArrowUp) {
      <polygon points="16 4 6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4" stroke-width="1.4" />
    }
    @case (IconNames.ArrowLeft) {
      <polygon points="14 26 15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26" />
    }
    @case (IconNames.ArrowRight) {
      <polygon points="18 6 16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6" />
    }
    @case (IconNames.ArrowDown) {
      <polygon points="24.59 16.59 17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59" stroke-width="1.4" />
    }
    @case (IconNames.Menu) {
      <rect x="4" y="8" width="24" height="2" />
      <rect x="4" y="14" width="24" height="2" />
      <rect x="4" y="20" width="24" height="2" />
    }
    @case (IconNames.Menu4) {
      <rect x="4" y="6" width="24" height="2" />
      <rect x="4" y="24" width="24" height="2" />
      <rect x="4" y="12" width="24" height="2" />
      <rect x="4" y="18" width="24" height="2" />
    }
    @case (IconNames.PendingFilled) {
      <path
        d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z" />
      <path
        fill="none"
        d="M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z"
        data-icon-path="inner-path" />
    }
    @case (IconNames.Checkmark) {
      <path d="m13 24-9-9 1.414-1.414L13 21.171 26.586 7.586 28 9 13 24z" />
    }
    @case (IconNames.CheckmarkFilled) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z" />
      <polygon id="inner-path" class="cls-1" points="14 21.591 9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591" />
    }
    @case (IconNames.Chart3D) {
      <path
        d="M28,23v3.5859l-5-5V15a1,1,0,0,0-.5527-.8945L17,11.3818V5.8281l2.5859,2.586L21,7,16,2,11,7l1.4141,1.4141L15,5.8281v5.5537L9.5527,14.1055A1,1,0,0,0,9,15v6.5859l-5,5V23H2v7H9V28H5.4141l4.7832-4.7832,5.3554,2.6777a1.001,1.001,0,0,0,.8946,0l5.3554-2.6777L26.5859,28H23v2h7V23Zm-13,.3818-4-2V16.6182l4,2Zm1-6.5L12.2363,15,16,13.1182,19.7637,15Zm5,4.5-4,2V18.6182l4-2Z" />
    }
    @case (IconNames.Notification) {
      <path
        d="M28.7071,19.293,26,16.5859V13a10.0136,10.0136,0,0,0-9-9.9492V1H15V3.0508A10.0136,10.0136,0,0,0,6,13v3.5859L3.2929,19.293A1,1,0,0,0,3,20v3a1,1,0,0,0,1,1h7v.7768a5.152,5.152,0,0,0,4.5,5.1987A5.0057,5.0057,0,0,0,21,25V24h7a1,1,0,0,0,1-1V20A1,1,0,0,0,28.7071,19.293ZM19,25a3,3,0,0,1-6,0V24h6Zm8-3H5V20.4141L7.707,17.707A1,1,0,0,0,8,17V13a8,8,0,0,1,16,0v4a1,1,0,0,0,.293.707L27,20.4141Z" />
    }
    @case (IconNames.Home) {
      <path
        d="M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.Money) {
      <rect x="2" y="22" width="28" height="2" />
      <rect x="2" y="26" width="28" height="2" />
      <path d="M24,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" />
      <path d="M16,16a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,16Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,10Z" />
      <path d="M8,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z" />
      <path d="M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z" />
    }
    @case (IconNames.ChartHistogram) {
      <path
        d="M6,16c2.9727,0,4.2324-2.251,5.3447-4.2373C12.4741,9.7441,13.45,8,16,8s3.5259,1.7441,4.6553,3.7627C21.7676,13.749,23.0273,16,26,16h4V14H26c-1.7129,0-2.4834-1.2207-3.5991-3.2144C21.2075,8.6543,19.7231,6,16,6s-5.2075,2.6543-6.4009,4.7856C8.4834,12.7793,7.7129,14,6,14H4V2H2V28a2,2,0,0,0,2,2H30V28H28V22H26v6H21.9992L22,20H20v8H16V16H14V28H9.9992L10,20H8v8H4V16Z" />
    }
    @case (IconNames.Folder) {
      <path
        d="M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z"
        transform="translate(0)" />
    }
    @case (IconNames.SettingsAdjust) {
      <path
        d="M30,8h-4.1c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2v2h14.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30V8z M21,12c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S22.7,12,21,12z" />
      <path
        d="M2,24h4.1c0.5,2.3,2.5,4,4.9,4s4.4-1.7,4.9-4H30v-2H15.9c-0.5-2.3-2.5-4-4.9-4s-4.4,1.7-4.9,4H2V24z M11,20c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S9.3,20,11,20z" />
    }
    @case (IconNames.DnsService) {
      <rect x="20" y="20" width="10" height="2" />
      <rect x="20" y="24" width="6" height="2" />
      <path
        d="M30,17V16A13.9871,13.9871,0,1,0,19.23,29.625l-.46-1.9463A12.0419,12.0419,0,0,1,16,28c-.19,0-.375-.0186-.563-.0273A20.3044,20.3044,0,0,1,12.0259,17Zm-2.0415-2H21.9751A24.2838,24.2838,0,0,0,19.2014,4.4414,12.0228,12.0228,0,0,1,27.9585,15ZM16.563,4.0273A20.3044,20.3044,0,0,1,19.9741,15H12.0259A20.3044,20.3044,0,0,1,15.437,4.0273C15.625,4.0186,15.81,4,16,4S16.375,4.0186,16.563,4.0273Zm-3.7644.4141A24.2838,24.2838,0,0,0,10.0249,15H4.0415A12.0228,12.0228,0,0,1,12.7986,4.4414Zm0,23.1172A12.0228,12.0228,0,0,1,4.0415,17h5.9834A24.2838,24.2838,0,0,0,12.7986,27.5586Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.Store) {
      <path
        d="M30,10.68l-2-6A1,1,0,0,0,27,4H5a1,1,0,0,0-1,.68l-2,6A1.19,1.19,0,0,0,2,11v6a1,1,0,0,0,1,1H4V28H6V18h6V28H28V18h1a1,1,0,0,0,1-1V11A1.19,1.19,0,0,0,30,10.68ZM26,26H14V18H26Zm2-10H24V12H22v4H17V12H15v4H10V12H8v4H4V11.16L5.72,6H26.28L28,11.16Z"
        transform="translate(0)" />
    }
    @case (IconNames.Gift) {
      <path
        d="M26,10H23.2383A4.4867,4.4867,0,0,0,16,4.7065,4.4873,4.4873,0,0,0,8.7617,10H6a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2V28a2.0025,2.0025,0,0,0,2,2H24a2.0025,2.0025,0,0,0,2-2V18a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,26,10ZM17,7.5A2.5,2.5,0,1,1,19.5,10H17ZM12.5,5A2.503,2.503,0,0,1,15,7.5V10H12.5a2.5,2.5,0,0,1,0-5ZM6,12h9v4H6Zm2,6h7V28H8ZM24.0012,28H17V18h7ZM17,16V12h9l.0012,4Z" />
    }
    @case (IconNames.Timer) {
      <rect x="15" y="11" width="2" height="9" />
      <rect class="cls-1" x="13" y="2" width="6" height="2" />
      <path d="M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z" />
    }
    @case (IconNames.Building) {
      <path
        d="M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z" />
      <rect x="18" y="8" width="2" height="2" />
      <rect x="24" y="8" width="2" height="2" />
      <rect x="18" y="14" width="2" height="2" />
      <rect x="24" y="14" width="2" height="2" />
      <rect x="18" y="19.9996" width="2" height="2" />
      <rect x="24" y="19.9996" width="2" height="2" />
    }
    @case (IconNames.User) {
      <path d="M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z" />
      <path d="M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z" />
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32" />
    }
    @case (IconNames.Help) {
      <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2Zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12Z" />
      <circle cx="16" cy="23.5" r="1.5" />
      <path d="M17 8h-1.5a4.49 4.49 0 0 0-4.5 4.5v.5h2v-.5a2.5 2.5 0 0 1 2.5-2.5H17a2.5 2.5 0 0 1 0 5h-2v4.5h2V17a4.5 4.5 0 0 0 0-9Z" />
    }
    @case (IconNames.Warning) {
      <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2Zm0 26a12 12 0 1 1 12-12 12 12 0 0 1-12 12Z" />
      <path d="M15 8h2v11h-2zm1 14a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 22z" />
    }
    @case (IconNames.WarningFilled) {
      <style type="text/css">
        .st0 {
          fill: none;
        }

        .st1 {
          opacity: 0;
          fill-opacity: 0;
        }
      </style>
      <path
        id="Compound_Path"
        d="M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25  c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z" />
      <path
        id="inner-path"
        class="st1"
        d="M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22  C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z" />
    }
    @case (IconNames.WarningAlt) {
      <path d="M16 23a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 16 23zm-1-11h2v9h-2z" />
      <path d="M29 30H3a1 1 0 0 1-.887-1.461l13-25a1 1 0 0 1 1.774 0l13 25A1 1 0 0 1 29 30ZM4.65 28h22.7l.001-.003L16.002 6.17h-.004L4.648 27.997Z" />
    }
    @case (IconNames.Error) {
      <path
        d="M2 16A14 14 0 1 0 16 2 14 14 0 0 0 2 16Zm23.15 7.75L8.25 6.85a12 12 0 0 1 16.9 16.9ZM8.24 25.16a12 12 0 0 1-1.4-16.89l16.89 16.89a12 12 0 0 1-15.49 0Z" />
    }
    @case (IconNames.Bar) {
      <path d="M25 11H15a1 1 0 0 0-1 1v4a6.005 6.005 0 0 0 5 5.91V28h-3v2h8v-2h-3v-6.09A6.005 6.005 0 0 0 26 16v-4a1 1 0 0 0-1-1Zm-1 5a4 4 0 0 1-8 0v-3h8Z" />
      <path d="M15 1h-5a1 1 0 0 0-1 1v7.37A6.09 6.09 0 0 0 6 15v14a1 1 0 0 0 1 1h5v-2H8V15c0-3.188 2.231-4.02 2.316-4.051L11 10.72V3h3v5h2V2a1 1 0 0 0-1-1Z" />
    }
    @case (IconNames.Qr) {
      <rect x="24" y="26" width="2" height="2" transform="translate(-2 52) rotate(-90)" />
      <rect x="18" y="22" width="2" height="2" transform="translate(-4 42) rotate(-90)" />
      <polygon points="18 30 22 30 22 28 20 28 20 26 18 26 18 30" />
      <rect x="24.9999" y="23" width="4" height="2" transform="translate(2.9999 50.9999) rotate(-90)" />
      <polygon points="28 26 30 26 30 30 26 30 26 28 28 28 28 26" />
      <polygon points="26 20 26 18 30 18 30 22 28 22 28 20 26 20" />
      <polygon points="24 20 22 20 22 24 20 24 20 26 24 26 24 20" />
      <rect x="19" y="17" width="2" height="4" transform="translate(1 39) rotate(-90)" />
      <rect x="6" y="22" width="4" height="4" />
      <path d="M14,30H2V18H14ZM4,28h8V20H4Z" />
      <rect x="22" y="6" width="4" height="4" />
      <path d="M30,14H18V2H30ZM20,12h8V4H20Z" />
      <rect x="6" y="6" width="4" height="4" />
      <path d="M14,14H2V2H14ZM4,12h8V4H4Z" />
    }
    @case (IconNames.Wallet) {
      <path d="M22 17h2v2h-2z" />
      <path
        d="M28 8H4V5h22V3H4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2ZM4 26V10h24v3h-8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8v3Zm24-11v6h-8v-6Z" />
    }
    @case (IconNames.Enterprise) {
      <path d="M8 8h2v4H8zm0 6h2v4H8zm6-6h2v4h-2zm0 6h2v4h-2zm-6 6h2v4H8zm6 0h2v4h-2z" />
      <path d="M30 14a2 2 0 0 0-2-2h-6V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v26h28ZM4 4h16v24H4Zm18 24V14h6v14Z" />
    }
    @case (IconNames.StatusAcknowledge) {
      <path d="M24 30a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6zm0-10a4 4 0 1 0 4 4 4.005 4.005 0 0 0-4-4zm-12-4.41L9.41 13 8 14.41l4 4 7-7L17.59 10 12 15.59z" />
      <path d="M14 24a10 10 0 1 1 10-10h2a12 12 0 1 0-12 12Z" />
    }
    @case (IconNames.Identification) {
      <path d="M28 6v20H4V6h24m0-2H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z" />
      <path
        d="M6 10h7v2H6zm0 4h4v2H6zm17 4h-6a3 3 0 0 0-3 3v2h2v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h2v-2a3 3 0 0 0-3-3zm-3-1a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2 2 2 0 0 1 2-2z" />
    }
    @case (IconNames.UserProfile) {
      <path
        d="M12 4a5 5 0 1 1-5 5 5 5 0 0 1 5-5m0-2a7 7 0 1 0 7 7 7 7 0 0 0-7-7zm10 28h-2v-5a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v5H2v-5a7 7 0 0 1 7-7h6a7 7 0 0 1 7 7zm0-26h10v2H22zm0 5h10v2H22zm0 5h7v2h-7z" />
    }
    @case (IconNames.DataCheck) {
      <path d="m23 27.18-2.59-2.59L19 26l4 4 7-7-1.41-1.41L23 27.18z" />
      <circle cx="11" cy="8" r="1" />
      <circle cx="11" cy="16" r="1" />
      <circle cx="11" cy="24" r="1" />
      <path d="M24 3H8a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h8v-2H8v-6h18V5a2 2 0 0 0-2-2Zm0 16H8v-6h16Zm0-8H8V5h16Z" />
    }
    @case (IconNames.Hubspot) {
      <path
        fill-rule="evenodd"
        d="M20.35 3.893A2.086 2.086 0 0 0 19.265.022a2.087 2.087 0 0 0-1.078 3.874v2.74a9.04 9.04 0 0 0-6.146 3.54L5.417 5.304a2.453 2.453 0 1 0-1.14 1.846l6.672 4.91a9.018 9.018 0 0 0-.727 3.56c0 1.819.536 3.512 1.46 4.93L9.75 22.48l1.53 1.53 1.795-1.796A9.048 9.048 0 1 0 20.35 6.635V3.893ZM14.278 20.36l.25.25a6.885 6.885 0 1 0-.25-.25Z"
        clip-rule="evenodd" />
      <circle cx="9.492" cy="23.99" r="2.087" fill="#1D1D1D" />
    }
    @case (IconNames.StudySkip) {
      <path d="M22 9h5.2A11 11 0 0 0 7 15H5a13 13 0 0 1 23-8.3V3h2v8h-8Z" />
      <path
        d="M16 12a3 3 0 1 1-3 3 2.95 2.95 0 0 1 3-3m0-2a5 5 0 1 0 5 5 5 5 0 0 0-5-5zm7 20h-2v-3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v3H9v-3a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5z" />
    }
    @case (IconNames.UserFollow) {
      <polygon points="32 14 28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14" />
      <path d="M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z" transform="translate(0 0)" />
      <path d="M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z" transform="translate(0 0)" />
    }
    @case (IconNames.FlowConnect) {
      <path
        d="M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z" />
    }
    @case (IconNames.ShoppingCard) {
      <path
        d="M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z" />
    }
    @case (IconNames.DataViewAlt) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <circle cx="22" cy="24" r="2" />
      <path
        d="M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z" />
      <rect x="7" y="17" width="5" height="2" />
      <rect x="7" y="12" width="12" height="2" />
      <rect x="7" y="7" width="12" height="2" />
      <path d="M22,2,4,2A2.0058,2.0058,0,0,0,2,4V28a2.0058,2.0058,0,0,0,2,2h8V28H4V4H22V15h2V4A2.0058,2.0058,0,0,0,22,2Z" />
    }
    @case (IconNames.AppleStore) {
      <path
        d="M17.4415 13.8494C17.413 10.7623 20.034 9.26043 20.1539 9.19051C18.6695 7.0804 16.3687 6.79209 15.5602 6.76911C13.6278 6.57083 11.7534 7.89647 10.7691 7.89647C9.76508 7.89647 8.24925 6.78826 6.61553 6.82083C4.51321 6.85244 2.54646 8.03919 1.46779 9.88206C-0.758308 13.6396 0.901935 19.1615 3.03471 22.1988C4.10159 23.6863 5.34824 25.3472 6.97999 25.2888C8.57638 25.2246 9.17269 24.2965 11.0992 24.2965C13.008 24.2965 13.5679 25.2888 15.2321 25.2514C16.9454 25.2246 18.024 23.7572 19.0536 22.2563C20.2865 20.5514 20.7816 18.8723 20.8013 18.7861C20.761 18.7727 17.4739 17.5495 17.4415 13.8494Z"
        fill="black" />
      <path
        d="M14.2978 4.77107C15.1564 3.72416 15.7439 2.29986 15.5808 0.854492C14.3381 0.908131 12.784 1.6926 11.889 2.71652C11.0972 3.6188 10.3899 5.09769 10.5726 6.48846C11.9686 6.58999 13.4019 5.8017 14.2978 4.77107Z"
        fill="black" />
      <path
        d="M53.8402 20.343H51.2046L49.7608 16.4552H44.7426L43.3673 20.343H40.8013L45.7731 7.10718H48.844L53.8402 20.343ZM49.3256 14.8241L48.02 11.3679C47.8819 11.0149 47.6231 10.1834 47.2413 8.87454H47.1948C47.0428 9.43747 46.7979 10.2689 46.4613 11.3679L45.1789 14.8241H49.3256Z"
        fill="black" />
      <path
        d="M66.6269 15.4536C66.6269 17.0767 66.1151 18.3597 65.0915 19.3016C64.1746 20.14 63.0361 20.5587 61.6771 20.5587C60.2101 20.5587 59.1563 20.1072 58.5145 19.2041H58.4681V24.2317H55.9938V13.9408C55.9938 12.9204 55.9624 11.8731 55.9021 10.799H58.0782L58.2163 12.3117H58.2627C59.0879 11.1719 60.3401 10.603 62.0206 10.603C63.3344 10.603 64.4311 11.0476 65.3085 11.9377C66.1882 12.8289 66.6269 14.0005 66.6269 15.4536ZM64.1061 15.5312C64.1061 14.6022 63.8624 13.8364 63.3727 13.2337C62.8376 12.6051 62.1192 12.2908 61.2186 12.2908C60.6082 12.2908 60.0534 12.4659 59.5579 12.811C59.0612 13.1591 58.7362 13.6136 58.5842 14.1765C58.5076 14.4391 58.4693 14.6539 58.4693 14.823V16.4143C58.4693 17.1086 58.7176 17.6944 59.2144 18.1727C59.7111 18.6511 60.3564 18.8898 61.1502 18.8898C62.0821 18.8898 62.8075 18.5815 63.3262 17.9669C63.8462 17.3512 64.1061 16.5397 64.1061 15.5312Z"
        fill="black" />
      <path
        d="M79.4358 15.4536C79.4358 17.0767 78.924 18.3597 77.8992 19.3016C76.9835 20.14 75.845 20.5587 74.486 20.5587C73.019 20.5587 71.9652 20.1072 71.3246 19.2041H71.2782V24.2317H68.8038V13.9408C68.8038 12.9204 68.7725 11.8731 68.7122 10.799H70.8882L71.0263 12.3117H71.0727C71.8967 11.1719 73.149 10.603 74.8307 10.603C76.1433 10.603 77.24 11.0476 78.1197 11.9377C78.9959 12.8289 79.4358 14.0005 79.4358 15.4536ZM76.915 15.5312C76.915 14.6022 76.6702 13.8364 76.1804 13.2337C75.6454 12.6051 74.9293 12.2908 74.0276 12.2908C73.4159 12.2908 72.8623 12.4659 72.3656 12.811C71.8689 13.1591 71.5451 13.6136 71.3931 14.1765C71.3176 14.4391 71.2782 14.6539 71.2782 14.823V16.4143C71.2782 17.1086 71.5265 17.6944 72.0209 18.1727C72.5177 18.6501 73.1629 18.8898 73.9591 18.8898C74.891 18.8898 75.6164 18.5815 76.1351 17.9669C76.6551 17.3512 76.915 16.5397 76.915 15.5312Z"
        fill="black" />
      <path
        d="M93.7564 16.6311C93.7564 17.757 93.3003 18.673 92.3847 19.3801C91.3784 20.1529 89.9776 20.5388 88.1776 20.5388C86.5157 20.5388 85.1833 20.2643 84.1748 19.7143L84.7481 17.9469C85.8344 18.5099 87.0263 18.7923 88.325 18.7923C89.2569 18.7923 89.9823 18.6113 90.5034 18.2513C91.0222 17.8912 91.281 17.4079 91.281 16.8051C91.281 16.2681 91.0674 15.8155 90.6392 15.4485C90.2132 15.0815 89.5018 14.7404 88.5084 14.4251C85.8042 13.5608 84.4533 12.2947 84.4533 10.6298C84.4533 9.54175 84.9269 8.64962 85.875 7.9554C86.8197 7.26019 88.0801 6.91309 89.6562 6.91309C91.0616 6.91309 92.2291 7.12294 93.1611 7.54166L92.5425 9.27023C91.6721 8.86445 90.6879 8.66155 89.5865 8.66155C88.7161 8.66155 88.036 8.84555 87.5486 9.21155C87.1366 9.53877 86.93 9.93759 86.93 10.41C86.93 10.9332 87.1656 11.3658 87.6391 11.706C88.0511 12.0202 88.7997 12.3604 89.886 12.7274C91.2148 13.1859 92.1908 13.722 92.8187 14.3366C93.4443 14.9493 93.7564 15.7161 93.7564 16.6311Z"
        fill="black" />
      <path
        d="M101.937 12.3903H99.2098V17.024C99.2098 18.2026 99.6903 18.7913 100.654 18.7913C101.096 18.7913 101.462 18.7585 101.753 18.6929L101.821 20.3031C101.334 20.4593 100.692 20.5378 99.8969 20.5378C98.9197 20.5378 98.156 20.2822 97.6047 19.772C97.0558 19.2608 96.7796 18.4035 96.7796 17.199V12.3883H95.1548V10.7969H96.7796V9.04947L99.2098 8.4209V10.7969H101.937V12.3903Z"
        fill="black" />
      <path
        d="M114.243 15.4923C114.243 16.9593 113.754 18.1638 112.776 19.1056C111.752 20.0754 110.391 20.5587 108.696 20.5587C107.062 20.5587 105.761 20.0943 104.791 19.1653C103.82 18.2364 103.335 17.0638 103.335 15.6505C103.335 14.1715 103.834 12.9602 104.836 12.0183C105.835 11.0754 107.184 10.604 108.879 10.604C110.513 10.604 111.828 11.0685 112.821 11.9984C113.77 12.9005 114.243 14.0651 114.243 15.4923ZM111.676 15.561C111.676 14.6808 111.457 13.9259 111.012 13.2963C110.494 12.5345 109.752 12.1545 108.791 12.1545C107.796 12.1545 107.041 12.5355 106.522 13.2963C106.078 13.9269 105.858 14.6937 105.858 15.6008C105.858 16.481 106.078 17.2358 106.522 17.8644C107.057 18.6263 107.805 19.0062 108.769 19.0062C109.714 19.0062 110.455 18.6183 110.99 17.8445C111.446 17.203 111.676 16.4402 111.676 15.561Z"
        fill="black" />
      <path
        d="M122.287 12.6638C122.042 12.625 121.781 12.6051 121.507 12.6051C120.636 12.6051 119.963 12.8866 119.49 13.4505C119.078 13.9478 118.871 14.5764 118.871 15.3352V20.3429H116.398L116.421 13.8046C116.421 12.7046 116.39 11.703 116.328 10.8H118.484L118.574 12.626H118.643C118.904 11.9984 119.316 11.4932 119.88 11.1142C120.431 10.7731 121.026 10.603 121.668 10.603C121.897 10.603 122.103 10.617 122.287 10.6418V12.6638Z"
        fill="black" />
      <path
        d="M133.353 15.1195C133.353 15.4994 133.324 15.8197 133.263 16.0812H125.84C125.869 17.0241 126.227 17.7452 126.917 18.2424C127.542 18.687 128.351 18.9098 129.345 18.9098C130.444 18.9098 131.447 18.7596 132.348 18.4583L132.736 19.9302C131.682 20.3241 130.438 20.52 129.002 20.52C127.275 20.52 125.92 20.0844 124.933 19.2142C123.949 18.3439 123.456 17.1753 123.456 15.7093C123.456 14.2701 123.914 13.0716 124.832 12.1159C125.793 11.0954 127.092 10.5852 128.726 10.5852C130.331 10.5852 131.546 11.0954 132.372 12.1159C133.025 12.9264 133.353 13.929 133.353 15.1195ZM130.994 14.5695C131.01 13.9409 130.849 13.3979 130.513 12.9394C130.085 12.3496 129.427 12.0552 128.542 12.0552C127.733 12.0552 127.075 12.3426 126.572 12.9195C126.16 13.378 125.915 13.928 125.84 14.5685H130.994V14.5695Z"
        fill="black" />
    }
    @case (IconNames.PlayStore) {
      <path
        d="M0.980724 1.36389C0.70978 1.64042 0.552979 2.07097 0.552979 2.62854V22.5167C0.552979 23.0743 0.70978 23.5048 0.980724 23.7813L1.0476 23.842L12.478 12.7019V12.4388L1.0476 1.29869L0.980724 1.36389Z"
        fill="black" />
      <path
        d="M17.6667 16.4172L13.8608 12.702V12.4389L17.6714 8.72367L17.7567 8.77201L22.2693 11.2755C23.5572 11.9859 23.5572 13.155 22.2693 13.87L17.7567 16.3689L17.6667 16.4172Z"
        fill="black" />
      <path d="M17.0655 17.0606L13.1696 13.2622L1.67236 24.4732C2.10011 24.9116 2.79765 24.9644 3.59088 24.526L17.0655 17.0606Z" fill="black" />
      <path d="M17.0655 8.08022L3.59088 0.61486C2.79765 0.180945 2.10011 0.233778 1.67236 0.672189L13.1696 11.8787L17.0655 8.08022Z" fill="black" />
      <path
        d="M74.8671 8.23616C72.1251 8.23616 69.8851 10.2708 69.8851 13.078C69.8851 15.8625 72.1251 17.9184 74.8671 17.9184C77.615 17.9184 79.855 15.8625 79.855 13.078C79.855 10.2708 77.615 8.23616 74.8671 8.23616ZM74.8671 16.0119C73.3626 16.0119 72.0682 14.801 72.0682 13.078C72.0682 11.3322 73.3626 10.1427 74.8671 10.1427C76.3717 10.1427 77.6719 11.3322 77.6719 13.078C77.6719 14.801 76.3717 16.0119 74.8671 16.0119ZM63.9968 8.23616C61.2489 8.23616 59.0148 10.2708 59.0148 13.078C59.0148 15.8625 61.2489 17.9184 63.9968 17.9184C66.7432 17.9184 68.9789 15.8625 68.9789 13.078C68.9789 10.2708 66.7432 8.23616 63.9968 8.23616ZM63.9968 16.0119C62.4908 16.0119 61.192 14.801 61.192 13.078C61.192 11.3322 62.4908 10.1427 63.9968 10.1427C65.5013 10.1427 66.7957 11.3322 66.7957 13.078C66.7957 14.801 65.5013 16.0119 63.9968 16.0119ZM51.0616 9.72016V11.7776H56.1005C55.9531 12.9272 55.5591 13.7723 54.955 14.3614C54.2195 15.0728 53.0739 15.8625 51.0616 15.8625C47.9606 15.8625 45.5323 13.4223 45.5323 10.3988C45.5323 7.37536 47.9606 4.93523 51.0616 4.93523C52.7383 4.93523 53.9583 5.57407 54.8587 6.40215L56.3457 4.9523C55.0863 3.7799 53.411 2.87926 51.0616 2.87926C46.8092 2.87926 43.2354 6.25276 43.2354 10.3988C43.2354 14.5449 46.8092 17.9184 51.0616 17.9184C53.36 17.9184 55.0863 17.1843 56.4435 15.807C57.8342 14.451 58.2676 12.5445 58.2676 11.005C58.2676 10.5269 58.2267 10.0872 58.1538 9.72016H51.0616ZM103.955 11.3151C103.545 10.2324 102.28 8.23616 99.7029 8.23616C97.1492 8.23616 95.023 10.1982 95.023 13.078C95.023 15.7899 97.1273 17.9184 99.9481 17.9184C102.229 17.9184 103.545 16.5625 104.087 15.7728L102.394 14.673C101.829 15.4783 101.06 16.0119 99.9481 16.0119C98.8434 16.0119 98.051 15.5181 97.5432 14.5449L104.184 11.8658L103.955 11.3151ZM97.1842 12.9272C97.1273 11.0605 98.6712 10.1043 99.7774 10.1043C100.644 10.1043 101.38 10.5269 101.625 11.1316L97.1842 12.9272ZM91.7862 17.6239H93.9694V3.39574H91.7862V17.6239ZM88.211 9.31466H88.138C87.6477 8.74838 86.7123 8.23616 85.5273 8.23616C83.0407 8.23616 80.7671 10.3647 80.7671 13.0937C80.7671 15.807 83.0407 17.9184 85.5273 17.9184C86.7123 17.9184 87.6477 17.4019 88.138 16.8186H88.211V17.5129C88.211 19.364 87.1967 20.3586 85.5609 20.3586C84.2271 20.3586 83.3997 19.4195 83.0582 18.6298L81.1596 19.4024C81.7069 20.6858 83.1559 22.2651 85.5609 22.2651C88.1205 22.2651 90.2802 20.7968 90.2802 17.2241V8.53069H88.211V9.31466ZM85.7141 16.0119C84.2096 16.0119 82.9502 14.784 82.9502 13.0937C82.9502 11.3877 84.2096 10.1427 85.7141 10.1427C87.1967 10.1427 88.3656 11.3877 88.3656 13.0937C88.3656 14.784 87.1967 16.0119 85.7141 16.0119ZM114.176 3.39574H108.955V17.6239H111.132V12.2329H114.176C116.594 12.2329 118.966 10.5269 118.966 7.81359C118.966 5.1017 116.588 3.39574 114.176 3.39574ZM114.233 10.2537H111.132V5.37488H114.233C115.859 5.37488 116.787 6.69098 116.787 7.81359C116.787 8.91485 115.859 10.2537 114.233 10.2537ZM127.692 8.20913C126.119 8.20913 124.483 8.88639 123.811 10.3875L125.743 11.1771C126.159 10.3875 126.923 10.1314 127.732 10.1314C128.861 10.1314 130.007 10.793 130.024 11.9611V12.1105C129.63 11.8885 128.787 11.5599 127.749 11.5599C125.668 11.5599 123.548 12.6768 123.548 14.7612C123.548 16.6678 125.252 17.8957 127.168 17.8957C128.634 17.8957 129.442 17.2511 129.95 16.5013H130.024V17.6011H132.127V12.1432C132.127 9.62056 130.195 8.20913 127.692 8.20913ZM127.43 16.0062C126.717 16.0062 125.725 15.6618 125.725 14.801C125.725 13.6998 126.963 13.2772 128.034 13.2772C128.993 13.2772 129.442 13.4835 130.024 13.7553C129.854 15.0728 128.69 16.0062 127.43 16.0062ZM139.788 8.52073L137.286 14.6886H137.211L134.624 8.52073H132.276L136.164 17.1401L133.945 21.9365H136.22L142.211 8.52073H139.788ZM120.162 17.6239H122.345V3.39574H120.162V17.6239Z"
        fill="black" />
    }
    @case (IconNames.UserAvatar) {
      <path d="M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z" />
      <path
        d="M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z" />
    }
    @case (IconNames.ShoppingCardArrowDown) {
      <circle cx="10" cy="28" r="2" />
      <circle cx="24" cy="28" r="2" />
      <path
        d="M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
        transform="translate(0)" />
      <polygon points="21.586 6.586 18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586" />
    }
    @case (IconNames.RecordingFilled) {
      <circle cx="16" cy="16" r="4" />
      <path
        d="M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6
		S19.3,22,16,22z" />
    }
    @case (IconNames.Recording) {
      <circle cx="16" cy="16" r="4" />
      <path
        d="M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6
		S19.3,22,16,22z" />
    }
    @case (IconNames.Copy) {
      <path d="M28 10v18H10V10h18m0-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Z" />
      <path d="M4 18H2V4a2 2 0 0 1 2-2h14v2H4Z" />
    }
    @case (IconNames.Upload) {
      <polygon points="11 18 12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18" />
      <path
        d="M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z" />
    }
    @case (IconNames.Document) {
      <path
        d="M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3  z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z" />
    }
    @case (IconNames.Plug) {
      <path
        d="M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z" />
    }
    @case (IconNames.Friendship) {
      <path
        d="M25,10H7a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H12V28H8V19H6V13a1.0009,1.0009,0,0,1,1-1H25a1.0009,1.0009,0,0,1,1,1v6H24v9H20V16H18V28a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21a2.0023,2.0023,0,0,0,2-2V13A3.0033,3.0033,0,0,0,25,10Z"
        transform="translate(0 0)" />
      <path d="M10,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,10,3Z" transform="translate(0 0)" />
      <path d="M22,9a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,22,3Z" transform="translate(0 0)" />
    }
    @case (IconNames.Download) {
      <path d="M26,24v4H6V24H4v4H4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2h0V24Z" />
      <polygon points="26 14 24.59 12.59 17 20.17 17 2 15 2 15 20.17 7.41 12.59 6 14 16 24 26 14" />
    }
    @case (IconNames.Send) {
      <path
        d="M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z" />
    }
    @case (IconNames.MenuDots) {
      <circle cx="16" cy="8" r="2" />
      <circle cx="16" cy="16" r="2" />
      <circle cx="16" cy="24" r="2" />
    }
    @case (IconNames.CheckmarkOutline) {
      <polygon points="14 21.414 9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414" />
      <path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z" />
    }
    @case (IconNames.Filter) {
      <path
        d="M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z" />
    }
    @case (IconNames.ViewOff) {
      <path
        d="M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z" />
      <path d="M12,15.73a4,4,0,0,1,3.7-3.7l1.81-1.82a6,6,0,0,0-7.33,7.33Z" />
      <path
        d="M30.94,15.66A16.4,16.4,0,0,0,25.2,8.22L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.1A15.29,15.29,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM20,16a4,4,0,0,1-6,3.44L19.44,14A4,4,0,0,1,20,16Zm-4,9a13.05,13.05,0,0,1-6-1.58l2.54-2.54a6,6,0,0,0,8.35-8.35l2.87-2.87A14.54,14.54,0,0,1,28.93,16C26.9,21.07,21.3,25,16,25Z" />
    }
    @case (IconNames.Bookmark) {
      <path d="M24,4V26.75l-7.1-3.59-.9-.45-.9.45L8,26.75V4H24m0-2H8A2,2,0,0,0,6,4V30L16,25,26,30V4A2,2,0,0,0,24,2Z" />
    }
    @case (IconNames.PlayFilled) {
      <path
        id="_inner-path_"
        data-name="&lt;inner-path&gt;"
        class="cls-1"
        d="M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z" />
      <path d="M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z" />
    }
    @case (IconNames.TrashCan) {
      <rect x="12" y="12" width="2" height="12" />
      <rect x="18" y="12" width="2" height="12" />
      <path d="M4,6V8H6V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8h2V6ZM8,28V8H24V28Z" />
      <rect x="12" y="2" width="8" height="2" />
    }
    @case (IconNames.DocumentPdf) {
      <polygon points="30 18 30 16 24 16 24 26 26 26 26 22 29 22 29 20 26 20 26 18 30 18" />
      <path d="M19,26H15V16h4a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,19,26Zm-2-2h2a1.0011,1.0011,0,0,0,1-1V19a1.0011,1.0011,0,0,0-1-1H17Z" />
      <path d="M11,16H6V26H8V23h3a2.0027,2.0027,0,0,0,2-2V18A2.0023,2.0023,0,0,0,11,16ZM8,21V18h3l.001,3Z" />
      <path
        d="M22,14V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V28a2,2,0,0,0,2,2H20V28H4V4h8v6a2.0059,2.0059,0,0,0,2,2h6v2Zm-8-4V4.4L19.6,10Z" />
    }
    @case (IconNames.Terminal) {
      <path
        d="M605.72 754.95c-13.61 0-23.84-8.65-28.03-22.59h35.56v-7.53H576.1c-.33-2.5-.5-5.01-.5-7.53 0-1.24.04-2.5.1-3.76h37.55V706h-36.76c2.29-13.73 9.69-26.35 29.23-26.35 14.51 0 20.83 6.2 26.84 16.9l6.56-3.68c-6.05-10.78-14.28-20.75-33.4-20.75-23.93 0-37.65 16.47-37.65 45.18 0 26.6 15.48 45.18 37.65 45.18 19.12 0 27.35-9.97 33.4-20.75l-6.56-3.68c-6.01 10.7-12.33 16.9-26.84 16.9z" />
      <circle cx="450.96" cy="685.93" r="20.88" />
      <circle cx="395.06" cy="567.63" r="20.88" />
      <circle cx="450.96" cy="567.63" r="20.88" />
      <circle cx="506.63" cy="567.63" r="20.88" />
      <circle cx="395.06" cy="626.78" r="20.88" />
      <circle cx="450.96" cy="626.78" r="20.88" />
      <circle cx="506.63" cy="626.78" r="20.88" />
      <path
        d="M529.18 549.25H372.74c-4.59 0-8.91-1.67-12.25-4.31v189.7h180.93v-189.7c-3.34 2.64-7.65 4.31-12.24 4.31zm0 0H372.74c-4.59 0-8.91-1.67-12.25-4.31v189.7h180.93v-189.7c-3.34 2.64-7.65 4.31-12.24 4.31zm0 0H372.74c-4.59 0-8.91-1.67-12.25-4.31v189.7h180.93v-189.7c-3.34 2.64-7.65 4.31-12.24 4.31zm0 0H372.74c-4.59 0-8.91-1.67-12.25-4.31v189.7h180.93v-189.7c-3.34 2.64-7.65 4.31-12.24 4.31z"
        style="fill: none" />
      <path
        d="M565.64 386.55c-3.9-6.54-10.02-10.99-16.84-12.8-1.81-.56-3.62-.84-5.56-.97H360.49c-2.5 0-5.01.27-7.37.97-11.83 3.34-20.46 14.06-20.46 26.86v334.02c0 15.31 12.52 27.84 27.83 27.84h138.49v-27.84H360.49V400.61h180.94v231.42l27.83-16.47V398.8c-.14-4.17-1.25-8.35-3.62-12.25z" />
      <path
        d="M529.18 275.21H372.74c-10.86 0-19.62 8.77-19.62 19.62v78.91c2.37-.7 4.87-.97 7.38-.97h12.25v-77.94h107.58v77.94h19.62v-77.94h29.23v77.94h14.06c1.95.14 3.76.42 5.57.97v-78.91c-.01-10.85-8.78-19.62-19.63-19.62z" />
      <path
        d="M527.51 445.43v49.69c0 13.08-10.58 23.66-23.66 23.66H397.79c-13.08 0-23.66-10.58-23.66-23.66v-49.69c0-13.08 10.58-23.66 23.66-23.66h106.05c13.09 0 23.67 10.58 23.67 23.66z" />
      <path
        d="m711.87 652.56-94.56-55.94a15.695 15.695 0 0 0-8.02-2.19c-2.78 0-5.55.72-8.03 2.2l-32.01 18.94-27.83 16.47-34.72 20.54a15.726 15.726 0 0 0-7.73 13.56v108.74c0 5.58 2.95 10.73 7.73 13.56l94.56 55.94c2.48 1.48 5.25 2.21 8.03 2.21 2.77 0 5.54-.73 8.02-2.21l94.56-55.94c4.79-2.82 7.74-7.98 7.74-13.56V666.13c0-5.58-2.96-10.73-7.74-13.57zm-23.78 113.33-78.8 46.61-78.8-46.61v-90.77l10.93-6.47 27.83-16.47 40.03-23.68 78.8 46.62v90.77z" />
    }
    @case (IconNames.YouTube) {
      <path
        d="M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z" />
    }
    @case (IconNames.LinkedIn) {
      <style type="text/css">
        .st0 {
          fill: none;
        }
      </style>
      <path
        d="M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4
	H7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3
	H21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z
	" />
    }
    @case (IconNames.Facebook) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <path
        d="M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.WhitePaper) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <polygon points="22 27.1798 19.41 24.5899 18 26 22 30 30 22 28.5899 20.59 22 27.1798" />
      <rect x="9" y="17" width="7" height="2" />
      <rect x="9" y="12" width="12" height="2" />
      <rect x="9" y="7" width="12" height="2" />
      <path d="m16,30H6c-1.103,0-2-.8972-2-2V4c0-1.1028.897-2,2-2h18c1.103,0,2,.8972,2,2v15h-2V4H6v24h10v2Z" />
    }
    @case (IconNames.MobileCheck) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <polygon points="20 27.18 17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18" />
      <path d="M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z" />
    }
    @case (IconNames.Sms) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <path
        d="M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
        transform="translate(0 0)" />
      <rect x="8" y="10" width="16" height="2" />
      <rect x="8" y="16" width="10" height="2" />
    }
    @case (IconNames.Headset) {
      <defs>
        <style>
          .cls-1 {
            fill: none;
          }
        </style>
      </defs>
      <path
        d="M25,10h-.06A9,9,0,0,0,7.06,10H7A5,5,0,0,0,7,20H9V11a7,7,0,0,1,14,0V21a4,4,0,0,1-3.17,3.91,4,4,0,1,0,.05,2A6,6,0,0,0,25,21V20a5,5,0,0,0,0-10ZM4,15a3,3,0,0,1,3-3v6A3,3,0,0,1,4,15ZM16,28a2,2,0,1,1,2-2A2,2,0,0,1,16,28Zm9-10V12a3,3,0,0,1,0,6Z"
        transform="translate(0)" />
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32" />
    }
    @case (IconNames.Code) {
      <polygon points="31 16 24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16" />
      <polygon points="1 16 8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16" />
      <rect x="5.91" y="15" width="20.17" height="2" transform="translate(-3.6 27.31) rotate(-75)" />
    }
    @case (IconNames.Horn) {
      <path
        class="cls-1"
        d="M26,6V8.17L5.64,11.87a2,2,0,0,0-1.64,2v4.34a2,2,0,0,0,1.64,2L8,20.56V24a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V22.74l6,1.09V26h2V6ZM18,24H10V20.93l8,1.45ZM6,18.17V13.83L26,10.2V21.8Z" />
    }
    @case (IconNames.Chemistry) {
      <path
        d="M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
        transform="translate(0 0)" />
    }
    @case (IconNames.Book) {
      <rect x="19" y="10" width="7" height="2" />
      <rect x="19" y="15" width="7" height="2" />
      <rect x="19" y="20" width="7" height="2" />
      <rect x="6" y="10" width="7" height="2" />
      <rect x="6" y="15" width="7" height="2" />
      <rect x="6" y="20" width="7" height="2" />
      <path d="M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z" />
    }
    @case (IconNames.Image) {
      <path
        d="M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z" />
      <path
        d="M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z" />
    }
    @case (IconNames.Person) {
      <path
        d="M64.5395 158.131C17.4012 158.131 2.3429 198.777 0.706055
              219.101C90.0732 293.737 175.702 250.199 207.346 219.101C207.346 172.617 163.699 159.086 141.876 158.131H64.5395Z" />
      <circle cx="105.56" cy="66.371" r="65.7773" fill="#DEDFFF" />
    }
    @case (IconNames.Product) {
      <rect x="8" y="18" width="6" height="2" />
      <rect x="8" y="22" width="10" height="2" />
      <path
        d="M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z" />
    }
    @case (IconNames.Receipt) {
      <rect x="21" y="16" width="2" height="2" />
      <rect x="9" y="16" width="8" height="2" />
      <rect x="21" y="12" width="2" height="2" />
      <rect x="9" y="12" width="8" height="2" />
      <rect x="9" y="8" width="14" height="2" />
      <path
        d="M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z" />
    }
    @case (IconNames.Activity) {
      <path
        d="M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z" />
    }
    @case (IconNames.ArrowsVertical) {
      <polygon points="27.6,20.6 24,24.2 24,4 22,4 22,24.2 18.4,20.6 17,22 23,28 29,22 " />
      <polygon points="9,4 3,10 4.4,11.4 8,7.8 8,28 10,28 10,7.8 13.6,11.4 15,10 " />
    }
    @case (IconNames.ViewOffFilled) {
      <path
        d="M30.94,15.66a16.4,16.4,0,0,0-5.73-7.45L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.09A15.38,15.38,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5a6.46,6.46,0,0,1-3.83-1.26L14,19.43A4,4,0,0,0,19.43,14l1.81-1.81A6.49,6.49,0,0,1,16,22.5Z" />
      <path
        d="M4.53,21.81l5-5A6.84,6.84,0,0,1,9.5,16,6.51,6.51,0,0,1,16,9.5a6.84,6.84,0,0,1,.79.05l3.78-3.77A14.39,14.39,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A15.86,15.86,0,0,0,4.53,21.81Z" />
    }
    @case (IconNames.ViewFilled) {
      <circle cx="16" cy="16" r="4" />
      <path
        d="M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z" />
    }
    @case (IconNames.CopyFile) {
      <path
        d="M27.4,14.7l-6.1-6.1C21,8.2,20.5,8,20,8h-8c-1.1,0-2,0.9-2,2v18c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V16.1 C28,15.6,27.8,15.1,27.4,14.7z M20,10l5.9,6H20V10z M12,28V10h6v6c0,1.1,0.9,2,2,2h6l0,10H12z" />
      <path d="M6,18H4V4c0-1.1,0.9-2,2-2h14v2H6V18z" />
    }
    @case (IconNames.Save) {
      <path
        d="M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z" />
    }
    @case (IconNames.Calendar) {
      <path
        d="M26,4h-4V2h-2v2h-8V2h-2v2H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V6C28,4.9,27.1,4,26,4z M26,26H6V12h20V26z M26,10H6V6h4v2h2V6h8v2h2V6h4V10z" />
    }
    @case (IconNames.Scope) {
      <path d="M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z" />
      <path d="M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21" />
    }
    @default {
      [{{ shape() }}]
    }
  }
</svg>
